import { createLiveVipOrder, getWechatAutoRenewId } from '@/api'
import {
  appFunc_IosLiveVipOrder,
  appFunc_EntrustWeb,
  appFunc_LiveOlderWxPay,
  appFunc_LiveOlderAliPay
} from '@/utils/bridge'
import { Toast } from 'vant'
import { isIOS } from '@/utils/device'

export default {
  data() {
    return {
      payLoading: false,
      unAutoRenewPayLoading: false,
      contractId: undefined,
      isPayFirtst: false,
      count: 0,
      timer: null
    }
  },
  methods: {
    // 立即购买
    handelBuy() {
      if (!this.isAgreement) return Toast(this.$t('请勾选会员购买协议'))

      try {
        const product = this.memberProducts[this.activeVipIndex || 0] || {}

        // 购买埋点
        const { aplus_queue } = window
        aplus_queue.push({
          action: 'aplus.record',
          arguments: [
            'purchase_membership',
            'CLK',
            {
              type:
                product.type == 1
                  ? `自动续费-${product.name}`
                  : `非自动续费-${product.name}`
            }
          ]
        })

        // IOS
        if (isIOS) {
          appFunc_IosLiveVipOrder({ configId: product.id, iosPayId: product.iosPayId, money: product.firtstPrice || product.currentPrice })
          this.delayCloseLoading()
          return
        }

        // 是否是自动续费 只处理android
        const isAuto = product.type == 1
        if (isAuto) {
          // 自动续费
          this.handleAutoRenewal(product)
        } else {
          // 非自动续费
          this.show = true
          this.activePay = ''
        }
      } catch (error) {
        console.log('autoRenewal payError', error)
      }
    },
    // 自动续费
    handleAutoRenewal(product) {
      try {
        if (this.payLoading) return
        // 微信签约
        getWechatAutoRenewId(product.id).then(res => {
          if (res.code === 1001) {
            // 已签约自动续费、走续费流程
            if (res.data) {
              this.contractId = res.data || undefined
              this.handleNoAutoRenewal('wx')
              return
            }
            this.payLoading = true
            // 签约自动续费
            createLiveVipOrder({
              money: product.firtstPrice || product.currentPrice,
              payType: 1, // 1 微信 2 支付宝 3 苹果内购
              configId: product.id
            }).then(res => {
              if (res.code === 1001 && res.data) {
                appFunc_EntrustWeb(res.data)
                this.delayCloseLoading()
              } else {
                this.closeLoading()
                Toast(this.$t('会员订单创建失败'))
              }
            })
          } else {
            this.closeLoading()
            Toast(res.message)
          }
        })
      } catch (error) {
        this.closeLoading()
        console.log('autoRenewal payError', error)
      }
    },

    // 非自动续费
    handleNoAutoRenewal(type) {
      if (this.unAutoRenewPayLoading) return
      this.activePay = type
      try {
        const product = this.memberProducts[this.activeVipIndex || 0] || {}
        // loading
        product.type === 1
          ? (this.payLoading = true)
          : (this.unAutoRenewPayLoading = true)

        createLiveVipOrder({
          money: product.firtstPrice || product.currentPrice,
          payType: type === 'wx' ? 1 : type === 'ali' ? 2 : 3, // 1 微信 2 支付宝 3 苹果内购
          configId: product.id,
          contractId: this.contractId || undefined,
          platform: 1
        }).then(res => {
          if (res.code === 1001 && res.data) {
            // console.log(res.data.alipayOrderInfoStr, type)

            if (product.type === 1) {
              console.log(
                '自动续费有签约id时，返回扣费申请结果',
                res.data.pappay
              )
              this.payLoading = false
              const { result_code, return_code } = res.data?.pappay || {}
              this.getOlderStatus()
              if (result_code === 'SUCCESS' && return_code === 'SUCCESS')
                return Toast(this.$t('会员购买成功'))
              return Toast(this.$t('会员购买失败'))
            }

            // 微信
            if (type === 'wx') {
              if (res.data.appId) {
                appFunc_LiveOlderWxPay(res.data)
                this.delayCloseLoading()
              } else {
                Toast(this.$t('会员订单创建失败'))
                this.closeLoading()
              }
            }
            // 支付宝
            if (type === 'ali') {
              if (res.data.alipayOrderInfoStr) {
                appFunc_LiveOlderAliPay(res.data)
                this.delayCloseLoading()
              } else {
                Toast(this.$t('会员订单创建失败'))
                this.closeLoading()
              }
            }
          } else {
            this.closeLoading()
            Toast(this.$t('会员订单创建失败'))
            console.log('noAutoRenewal payError', res.message)
          }
        })
      } catch (error) {
        this.closeLoading()
        console.log('noAutoRenewal payError', error)
      }
    },

    // 获取支付状态
    payStatus() {
      this.isIOS =
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent) //ios终端
      const addevpageshow = () => {
        //处理跳转外部链接后，ios回退标题不改变问题
        if (this.isIOS) {
          // 判断是否是ios机型
          window.addEventListener('pageshow', () => {
            // 执行想要的操作
            this.closeLoading()
            this.getOlderStatus()
          })
        }
        // 文档重新显示刷新接口
        document.addEventListener('visibilitychange', () => {
          console.log('visibilityState', document.visibilityState);
          
          // 文档重新显示刷新接口
          if (document.visibilityState == 'visible') {
            // 强制刷新
            // location.reload(true)
            this.getOlderStatus()
          }
          this.closeLoading()
        })
      }
      addevpageshow()
    },

    delayCloseLoading() {
      setTimeout(() => {
        this.payLoading = false
        this.unAutoRenewPayLoading = false
        this.isPayFirtst = true
      }, 3000)
    },
    closeLoading() {
      this.payLoading = false
      this.unAutoRenewPayLoading = false
      this.contractId = undefined
      this.show = false
    },
    getOlderStatus() {
      if(this.timer) return;
      this.getConfigList()
      this.timer = setInterval(() => {
        if (this.count > 20) return clearInterval(this.timer)
        this.getConfigList()
        this.count++
      }, 3000)
    }
  },
  destroyed() {
    if(this.timer) clearInterval(this.timer)
    this.count = 0
  },
}
